import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserProfileDirective } from './user-profile.directive';
import { ClickOutsideChatDirective } from './click-outside-chat.directive';
import { ObserveVisibilityDirective } from './visibility.directive';
import { DragDropFilesDirective } from './drag-drop-files.directive';


@NgModule({
    declarations: [UserProfileDirective, ClickOutsideChatDirective, ObserveVisibilityDirective, DragDropFilesDirective],
    exports: [UserProfileDirective, ClickOutsideChatDirective, ObserveVisibilityDirective, DragDropFilesDirective],
    imports     : [
        CommonModule
    ],
})
export class CommonDirectiveModule
{
}
